import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { Quotation as QuotationIcon } from '@bibliocommons/deprecated-base-icons';
import { bibShape, shelfItemShape, ugcQuotationShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import QuotationDisplay from '../../../shared/UGC/QuotationDisplay';
import QuotationUGCEditor from '../../../shared/UGC/UGCEditors/QuotationUGCEditor';
import AddButton from '../../../shared/UGC/AddButton';
import './QuotationsInfo.scss';

export default class ShelfListItemQuotationsInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <QuotationUGCEditor
          bib={this.props.bib}
          shelfItem={this.props.item}
          quotationsTransactions={this.props.quotationsTransactions}
          shelfTransactions={this.props.shelfTransactions}
          quotationsActions={this.props.quotationsActions}
          shelfActions={this.props.shelfActions}
          handleClose={this.closeEditor}
        />
      )
    );
  }

  render() {
    const {
      bib,
      item,
      owner,
      ownerQuotationsForBib,
      quotationsTransactions,
      shelfTransactions,
      quotationsActions,
      shelfActions
    } = this.props;

    if (ownerQuotationsForBib && ownerQuotationsForBib.size > 0) {
      const count = ownerQuotationsForBib.size;

      return (
        <div className="cp-shelf-list-item-quotations-info">
          <DisplayHeading>
            <FormattedMessage id="ugc_quotations_display_label" values={{ count }} />
          </DisplayHeading>
          <AddButton
            owner={owner}
            handleClick={this.openEditor}
            screenReaderMessage={
              <FormattedMessage id="ada_add_quotations" values={{ title: bib.getIn(['briefInfo', 'title']) }} />
            }
          />
          <ul className="quotations-display-list">
            {ownerQuotationsForBib.map(quotation => (
              <li className="quotation-display-item" key={`quotation-display-${quotation.get('id')}`}>
                <div className="left-block">
                  <QuotationIcon />
                </div>
                <div className="right-block">
                  <QuotationDisplay
                    bib={bib}
                    shelfItem={item}
                    owner={owner}
                    quotation={quotation}
                    quotationsTransactions={quotationsTransactions}
                    shelfTransactions={shelfTransactions}
                    quotationsActions={quotationsActions}
                    shelfActions={shelfActions}
                  />
                </div>
              </li>
            ))}
          </ul>

          <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
            {this.renderEditor()}
          </FullScreenOverlay>
        </div>
      );
    }

    return null;
  }
}

ShelfListItemQuotationsInfo.propTypes = {
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerQuotationsForBib: ImmutablePropTypes.listOf(ugcQuotationShape),
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
